import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Combina classes condicionais e resolve conflitos do Tailwind. */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

/** Formata número como moeda BRL. */
export function formatBRL(value) {
  const n = Number(value ?? 0)
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

/** Formata data ISO (AAAA-MM-DD) para dd/mm/aaaa. */
export function formatDate(iso) {
  if (!iso) return ''
  const [y, m, d] = String(iso).slice(0, 10).split('-')
  if (!y || !m || !d) return iso
  return `${d}/${m}/${y}`
}
